import axios from "axios";
import { useEffect, useState } from "react";
import localize from "../../../common/localize";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { List } from "@mui/material";
import NotificationItem from "../../../components/common/NotificationItem";
import EventItem from "../../event/components/EventItem";

export default function ClientEvents({ clientModelData }) {
  const { config, EVENTS_API } = useGlobalContext();
  const [eventsData, setEventsData] = useState({ Data: [] });

  const getEventsData = async (clientId) => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(
      `${EVENTS_API}/client/${clientId}`,
      requestConfig
    );
    setEventsData(data?.data?.Data);
  };

  useEffect(() => {
    if (clientModelData) {
      getEventsData(clientModelData.Id);
    }
  }, [clientModelData]);

  return (
    <div style={{ width: "100%" }}>
      <List className="flex flex-col gap-2 w-full">
        {eventsData?.length > 0 ? (
          eventsData?.map((item) => <EventItem event={item} />)
        ) : (
          <NotificationItem notification={{ message: localize.no_data }} />
        )}
      </List>
    </div>
  );
}
